export default __webpack_public_path__ + "img/sun-cloud-rain.82c1a1d.svg";